import BrandNoCatTopPostsDrawer from 'views/InstagramTrends/InstagramDrawerContent/TopPostsDrawer/BrandNoCatTopPostsDrawer';
import BrandTopPostsDrawer from 'views/InstagramTrends/InstagramDrawerContent/TopPostsDrawer/BrandTopPostsDrawer';
import CategoryTopPostsDrawer from 'views/InstagramTrends/InstagramDrawerContent/TopPostsDrawer/CategoryTopPostsDrawer';
import HashtagTopPostsDrawer from 'views/InstagramTrends/InstagramDrawerContent/TopPostsDrawer/HashtagTopPostsDrawer';
import RelatedHashtagBrandOnly from 'views/InstagramTrends/InstagramDrawerContent/TopPostsDrawer/RelatedHashtagBrandOnly';
import RelatedHashtagCategoryBrandDrawer from 'views/InstagramTrends/InstagramDrawerContent/TopPostsDrawer/RelatedHashtagCategoryBrandDrawer';
import RelatedHashtagCategoryDrawer from 'views/InstagramTrends/InstagramDrawerContent/TopPostsDrawer/RelatedHashtagCategoryDrawer';

const TopPostsDrawer = ({
    paginateType,
    year,
    week,
    countries,
    brands,
    categories,
    hashtags,
    name,
    displayQty,
}) => {
    switch (paginateType) {
        case 'brand':
            if (categories) {
                return (
                    <BrandTopPostsDrawer
                        year={year}
                        week={week}
                        countries={countries ? [countries.id] : null}
                        brands={brands ? [brands] : null}
                        categories={categories ? [categories] : null}
                        name={name}
                        displayQty={displayQty}
                    />
                );
            }
            return (
                <BrandNoCatTopPostsDrawer
                    year={year}
                    week={week}
                    countries={countries ? [countries.id] : null}
                    brands={brands ? [brands] : null}
                    name={name}
                    displayQty={displayQty}
                />
            );
        case 'hashtag':
            return (
                <HashtagTopPostsDrawer
                    year={year}
                    week={week}
                    countries={countries ? [countries.id] : null}
                    hashtags={hashtags ? [hashtags] : null}
                    name={name}
                    displayQty={displayQty}
                />
            );
        case 'related-hashtag-category-brand':
            return (
                <RelatedHashtagCategoryBrandDrawer
                    year={year}
                    week={week}
                    countries={countries || null}
                    brands={brands || null}
                    categories={categories || null}
                    hashtags={hashtags || null}
                    name={name}
                    displayQty={displayQty}
                />
            );
        case 'related-hashtag-brand-only':
            return (
                <RelatedHashtagBrandOnly
                    year={year}
                    week={week}
                    countries={countries || null}
                    brands={brands || null}
                    categories={categories || null}
                    hashtags={hashtags || null}
                    name={name}
                    displayQty={displayQty}
                />
            );
        case 'related-hashtag-category':
            return (
                <RelatedHashtagCategoryDrawer
                    year={year}
                    week={week}
                    countries={countries || null}
                    categories={categories || null}
                    hashtags={hashtags || null}
                    name={name}
                    displayQty={displayQty}
                />
            );
        case 'category':
        default:
            return (
                <CategoryTopPostsDrawer
                    year={year}
                    week={week}
                    countries={countries ? [countries.id] : null}
                    categories={categories ? [categories] : null}
                    name={name}
                    displayQty={displayQty}
                />
            );
    }
};

export default TopPostsDrawer;
